import { render, staticRenderFns } from "./FormRegularVisit.vue?vue&type=template&id=d8e666ac&scoped=true&"
import script from "./FormRegularVisit.vue?vue&type=script&lang=ts&"
export * from "./FormRegularVisit.vue?vue&type=script&lang=ts&"
import style0 from "./FormRegularVisit.vue?vue&type=style&index=0&id=d8e666ac&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d8e666ac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardSubtitle } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCard,VCardSubtitle,VCardText,VCol,VRow})
